import Vue from "vue";
import Vuex from "vuex";
import { API, graphqlOperation } from "aws-amplify";
import "../graphql/queries";
import "../graphql/mob_queries";
import { createSubject, updateOrderr } from "../graphql/mutations";
import { Auth } from "aws-amplify";
import APIAdapter from "./APIAdapter";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appVersion: "1.9.2",

    // kontext klienta
    client: "59 ", // nastaveno globalne pri inicializaci aplikace
    appInstance: "59", // nastaveno globalne pri inicializaci aplikace

    mobConfig: null,
    rentSelectSizeAutomatic: true,
    mobRentIcon: "mdi-video",
    mobSchoolIcon: "mdi-ski",

    locations: [],
    location: null,
    pointSells: [],
    pointSell: null,
    checkInDate: moment().add(1, "days").format("YYYY-MM-DD"), // vychozi hodnota je o 1 den navic
    checkOutDate: moment().add(1, "days").format("YYYY-MM-DD"), // vychozi hodnota je o 1 den navic
    user: null,
    segment: "RENT",
    orderrs: [], // seznam vsech objednavek
    currentOrderr: null,
    currentOrderrExpired: false, // staticky, aby nad Date objektem nemusel byt observu. Propisuje se po refreshi obj. a pri identifikaci expicitni expirace
    expireAt: null, // datum a cas, kdy objednavka expiruje. Ulozeno takto staticky kvuli eliminaci problikavani pri nacitani currentOrderr
    currentOrderrItemGroup: null,
    currentPayment: null,
    rentBookingMode: "CREATE",
    //articlesBySize: null,
    rentProduct: null,
    rentCategories: [],
    schoolCategories: [],
    staticContentList: [],
    rentProductRequirements: [],
    lastVisitedSegment: null, // jaky segment byl naposledy navstiven RENT nebo COURSE - pro ucely navratu na home page
  },
  mutations: {
    doSetMobConfig(state, payload) {
      state.mobConfig = payload;
    },

    doSetLocations(state, payload) {
      state.locations = payload;
    },

    doSetLocation(state, payload) {
      state.location = payload;
    },

    doSetPointSells(state, payload) {
      state.pointSells = payload;
    },

    doSetPointSell(state, payload) {
      state.pointSell = payload;
    },

    doSetCheckInDate(state, payload) {
      state.checkInDate = payload;
    },

    doSetCheckOutDate(state, payload) {
      state.checkOutDate = payload;
    },

    doSetRentCategories(state, payload) {
      state.rentCategories = payload;
    },

    doSetSchoolCategories(state, payload) {
      state.schoolCategories = payload;
    },

    doLogout(state) {
      state.user = null;
    },

    doLogin(state, user) {
      state.user = user;
    },

    doSetOrderr(state, orderr) {
      state.currentOrderr = orderr;
      if (orderr == null) {
        state.expireAt = null;
      } else {
        state.expireAt = orderr.expireAt;
      }
    },

    doSetCurrentOrderrExpired(state, isExpired) {
      state.currentOrderrExpired = isExpired;
    },

    doSetOrderrs(state, payload) {
      state.orderrs = payload;
    },

    doSetRentProduct(state, rentProduct) {
      state.rentProduct = rentProduct;
    },

    doSaveRentSearchParams(state, location, checkInDate, length) {
      state.location = location;
      state.checkInDate = checkInDate;
      state.length = length;
    },

    doSetCurrentPayment(state, payment) {
      state.currentPayment = payment;
    },

    doSetStaticContentList(state, staticContentList) {
      state.staticContentList = staticContentList;
    },

    doSetRentProductRequirements(state, rentProductRequirements) {
      state.rentProductRequirements = rentProductRequirements;
    },
  },

  actions: {
    async logout(context) {
      context.commit("doLogout");
    },

    async login(context, user) {
      context.commit("doLogin", user);
    },

    async saveRentSearchParams(context, location, checkInDate, length) {
      context.commit("doSaveRentSearchParams", location, checkInDate, length);
    },

    async loadMobConfig(context) {
      console.log("loadMobConfig -- start:");
      let mobConfig = null;
      try {
        console.log("loadMobConfig -- volani:");
        mobConfig = await APIAdapter.getMOBConfig(context.state.appInstance);
      } catch (e) {
        console.log("loadMobConfig -- ERROR");
        console.log(e);
      }

      console.log("loadMobConfig:");
      console.log(mobConfig);
      context.commit("doSetMobConfig", mobConfig);

      let offset = Math.max(mobConfig.rentBookingOffset);
      let cd = moment().add(offset, "days");
      cd.hour(8); // vychozi doba otevreni
      cd.minute(0);
      cd.second(0);

      // kdyz je predstih pouze 1 den a dnes je uz po zaviracce, posun to o den vice
      console.log("HR:");
      console.log(moment().hour());
      console.log("offset:");
      console.log(offset);
      if (moment().hour() >= 18 && offset <= 1) {
        //console.log("POSUNOUT O DEN");
        cd.add(1, "days");
      }

      let checkInDate = cd.format("YYYY-MM-DD");
      context.commit("doSetCheckInDate", checkInDate);
      context.commit("doSetCheckOutDate", checkInDate);
    },

    async loadLocations(context) {
      let locations = await APIAdapter.listLocations(
        context.state.appInstance,
        context.state.mobConfig.mobVersion
      );
      console.log("loadLocations:");
      console.log(locations);

      context.commit("doSetLocations", locations);

      if (
        context.state.location == null &&
        context.state.locations != null &&
        context.state.locations.length > 0
      ) {
        context.commit("doSetLocation", context.state.locations[0]);
      }
    },

    async loadPointSells(context) {
      let pointSells = await APIAdapter.listPointSell(
        context.state.appInstance,
        context.state.mobConfig.mobVersion
      );
      console.log("loadPointSells:");
      console.log(pointSells);

      context.commit("doSetPointSells", pointSells);

      //console.log(context.state.pointSell == null);

      if (
        context.state.pointSell == null &&
        context.state.pointSells != null &&
        context.state.pointSells.length > 0
      ) {
        context.commit("doSetPointSell", context.state.pointSells[0]);
      }
    },

    async loadListCategoriesAndProductsRent(context) {
      let result = await APIAdapter.loadListCategoriesAndProductsByProductType(
        context.state.appInstance,
        context.state.mobConfig.mobVersion,
        "RENTAL"
      );
      context.commit("doSetRentCategories", result);
    },

    async loadListCategoriesAndProductsSchool(context) {
      let result = await APIAdapter.loadListCategoriesAndProductsByProductType(
        context.state.appInstance,
        context.state.mobConfig.mobVersion,
        "SCHOOL"
      );
      context.commit("doSetSchoolCategories", result);
    },

    // vytvoreni prazdne 0objednavky
    // napojeno na backend pres Mutation
    async createOrderr(context) {
      try {
        const createOrderrDraftIn = {
          appInstance: context.state.appInstance,
          groups: context.state.appInstance,
          mobVersion: context.state.mobConfig.mobVersion,
          orderrPointSellId: context.state.pointSell.id,
        };

        let orderrId = await APIAdapter.createOrderrDraft(createOrderrDraftIn);

        console.log("objednavka zalozena");

        return await context.dispatch("getOrderr", orderrId);
      } catch (error) {
        console.error("Nepodarilo se zalozit objednavlku", error);
      }
    },

    // vola se jako akce pro zahajeni pridani polozky do kosiku
    async addToCart(context, orderrItemGroup) {
      console.log("store action bookOrderrItemGroup");
      console.log(orderrItemGroup);

      //await context.dispatch("loadCurrentOrderrDRAFT");

      /// create orderr, jestlize neexistuje
      if (context.state.currentOrderr == null) {
        await context.dispatch("createOrderr");
        console.log("store action bookOrderrItemGroup -- objednavka zalozena");
      }

      let subjectProfileIn = null;
      if (orderrItemGroup.subjectProfile != null) {
        subjectProfileIn = {
          name: orderrItemGroup.subjectProfile.name,
          weight: orderrItemGroup.subjectProfile.weight,
          height: orderrItemGroup.subjectProfile.height,
          shoeSize: orderrItemGroup.subjectProfile.shoeSize,
          age: orderrItemGroup.subjectProfile.age,
          gender: orderrItemGroup.subjectProfile.gender,
          rentAbilityLevel: orderrItemGroup.subjectProfile.rentAbilityLevel,
        };
      }

      let orderrItemGroupIn = {
        groups: context.state.appInstance,
        appInstance: context.state.appInstance,
        mobVersion: context.state.mobConfig.mobVersion,
        subjectProfile: subjectProfileIn,
        description: orderrItemGroup.description,
        itemsCount: orderrItemGroup.itemsCount,
        numberOfPersons: orderrItemGroup.numberOfPersons,
        length: orderrItemGroup.length,
        priceListType: orderrItemGroup.priceListType,
        dateStart: moment(orderrItemGroup.dateStart).format(
          "YYYY-MM-DDT08:00:00.000Z"
        ), // TODO: predelat podle otviracky a prevest na CEST
        dateEnd: moment(orderrItemGroup.dateEnd).format(
          "YYYY-MM-DDT18:00:00.000Z"
        ), // TODO: predelat podle otviracky a prevest na CEST
        orderrItemGroupOrderrId: context.state.currentOrderr.id,
        orderrItemGroupProductId: orderrItemGroup.product.id,
        orderrItemGroupLocationId: orderrItemGroup.location.id,
      };

      if (orderrItemGroup.set != null) {
        orderrItemGroupIn.orderrItemGroupSetId = orderrItemGroup.set.id;
      }

      let orderrItemsIn = [];

      for (let i = 0; i < orderrItemGroup.orderrItems.length; i++) {
        let oi = orderrItemGroup.orderrItems[i];

        let oiInput = {
          groups: context.state.appInstance,
          appInstance: context.state.appInstance,
          mobVersion: context.state.mobConfig.mobVersion,
          productId: oi.product.id,
          articleId: oi.article.id, //oi.article.id,
          lessons: oi.lessons,
          language: oi.language,
          skillLevelClient: oi.skillLevelClient,
          sameInstructorRequired: oi.sameInstructorRequired,
          numberOfHoursRequired: oi.numberOfHoursRequired,
        };

        orderrItemsIn.push(oiInput);
      }

      console.log("store action bookOrderrItemGroup -- zahajeno ukladani");

      let addToCartIn = {
        orderrItemGroup: orderrItemGroupIn,
        orderrItems: orderrItemsIn,
      };

      await APIAdapter.addOrderrItemGroupToCart(addToCartIn);

      console.log("store action bookOrderrItemGroup -- ulozeno.");

      context.dispatch("getOrderr", context.state.currentOrderr.id);
    },

    async removeFromCart(context, orderrItemGroup) {
      console.log("removeFromCart -- start");

      await APIAdapter.removeOrderrItemGroupFromCart(orderrItemGroup.id);

      console.log("removeFromCart -- hotovo");

      context.dispatch("getOrderr", context.state.currentOrderr.id);
    },

    // nacte seznam vsech objednavek a vybere z 0nich jednu, ktera je 00jako DRAFT
    // tuto objednavku nacte v plnem detail -- pres getOrderr
    // TODO: nacist pres dedikovanou metodu API - vyuzit filtr pres index
    async loadCurrentOrderrDRAFT(context) {
      console.log("loadCurrentOrderrDRAFT -- start");
      // nacti seznam vsech objednavek
      await context.dispatch("loadOrderrs");

      context.state.currentOrderr = null;

      // najdi vem tu rozpracovanou -- DRAFT
      if (context.state.orderrs == null) {
        throw "List of orders is null";
      }

      for (let i = 0; i < context.state.orderrs.length; i++) {
        let orderr = context.state.orderrs[i];
        console.log("orderr: ");
        console.log(orderr);
        if (orderr.bookingState == "DRAFT") {
          console.log("nalezen DRAFT");
          return context.dispatch("getOrderr", orderr.id);
        }
      }
      console.log("loadCurrentOrderrDRAFT -- end");
    },

    async loadCurrentOrderrCHECKOUT(context) {
      console.log("loadCurrentOrderrDRAFT -- start");
      // nacti seznam vsech objednavek
      await context.dispatch("loadOrderrs");

      context.state.currentOrderr = null;

      // najdi vem tu rozpracovanou -- DRAFT
      if (context.state.orderrs == null) {
        throw "List of orders is null";
      }

      for (let i = 0; i < context.state.orderrs.length; i++) {
        let orderr = context.state.orderrs[i];
        console.log("orderr: ");
        console.log(orderr);
        if (orderr.bookingState == "CHECKOUT") {
          console.log("nalezen CHECKOUT");
          return context.dispatch("getOrderr", orderr.id);
        }
      }
      console.log("loadCurrentOrderrDRAFT -- end");
    },

    // TODO: predelat ne neco jako nacti aktualni objednvku...
    async getOrderr(context, orderrId) {
      let orderr = await APIAdapter.getOrderr(orderrId);
      if (
        orderr.bookingState != "DRAFT" ||
        moment(orderr.expireAt).toDate() < moment().toDate()
      ) {
        context.commit("doSetCurrentOrderrExpired", true);
      } else {
        context.commit("doSetCurrentOrderrExpired", false);
      }

      context.commit("doSetOrderr", orderr);
    },

    async updateOrderrPickupAndPaymentInfo(context, payload) {
      console.log("updateOrderrPickupAndPaymentInfo");
      console.log(payload.orderrId);
      console.log(payload.datePickUp);
      console.log(payload.paymentMethod);

      await APIAdapter.updateOrderrPickupAndPaymentInfo(
        payload.orderrId,
        payload.datePickUp,
        payload.paymentMethod
      );

      // znovu nacist aktualni objednavku
      context.dispatch("getOrderr", payload.orderrId);
    },

    async loadOrderrs(context) {
      const orderrs = await APIAdapter.listOrderrs(context.state.appInstance);
      context.commit("doSetOrderrs", orderrs);
    },

    async createSubject(context, contactData) {
      console.log("createSubject -- start");
      let subjectInput = {
        groups: context.state.appInstance,
        appInstance: context.state.appInstance,
        mobVersion: context.state.mobConfig.mobVersion,
        cognitoId: context.state.user,
        name: contactData.name,
        surname: contactData.surname,
        email: contactData.email,
        phone: contactData.phone,
        nationality: null,
        documentType: "ID",
        documentNumber: contactData.documentNumber,
        documentValidTo: null,
      };

      let result = await API.graphql(
        graphqlOperation(createSubject, {
          input: subjectInput,
        })
      );

      console.log(result.data.createSubject);
      console.log("createSubject -- done");
      return result.data.createSubject;
    },

    async addSubjectToOrderr(context, payload) {
      console.log("addSubjectToOrderr -- start");

      let o = await context.dispatch("getOrderr", payload.orderr.id);

      console.log("addSubjectToOrderr -- orderr:");
      console.log(o);
      console.log("addSubjectToOrderr -- subject:");
      console.log(payload.subject);

      o.orderrClientId = payload.subject.id;

      await context.dispatch("updateOrderr", o);

      console.log("addSubjectToOrderr -- start");
    },

    async updateOrderr(context, orderr) {
      console.log("updateOrderr -- start");

      let updateOrderrInput = {
        id: orderr.id,
        groups: orderr.groups,
        appInstance: orderr.appInstance,
        bookingState: orderr.bookingState,
        orderrNumber: orderr.orderrNumber,
        price: orderr.price,
        itemsCount: orderr.itemsCount,
        expireAt: orderr.expireAt,
        orderrClientId: orderr.client.id,
      };

      let updateResult = await API.graphql(
        graphqlOperation(updateOrderr, {
          input: updateOrderrInput,
        })
      );

      console.log(updateResult);

      console.log("updateOrderr -- end");
    },

    async checkoutOrderr(context, payload) {
      console.log("checkoutOrderr -- start");

      let user = await Auth.currentAuthenticatedUser();

      console.log("user");
      console.log(user);

      let createSubjectIn = {
        ...payload.contactData,
        mobVersion: context.state.mobConfig.mobVersion,
        appInstance: context.state.appInstance,
        groups: context.state.appInstance,
        cognitoId: user.signInUserSession.accessToken.payload.username,
        documentType: "ID",
      };
      console.log(createSubjectIn);

      let orderrId = payload.orderrId;
      console.log(orderrId);

      await APIAdapter.checkoutOrderr(orderrId, createSubjectIn);

      console.log("checkoutOrderr -- end");
    },

    async getPayment(context, paymentId) {
      console.log("getPayment -- start");
      let payment = await APIAdapter.getPayment(paymentId);
      context.commit("doSetCurrentPayment", payment);
      console.log(payment);
      console.log("getPayment -- end");
    },

    async updateCurrentOrderrExpired(context, isExpired) {
      context.commit("doSetCurrentOrderrExpired", isExpired);
    },

    async expireOrderr(context) {
      context.commit("doSetOrderr", null);
      context.commit("doSetCurrentOrderrExpired", false);
    },

    async loadStaticContentList(context) {
      console.log("loadStaticContentList -- start");
      let staticContentList = await APIAdapter.listStaticContent(
        context.state.appInstance,
        context.state.mobConfig.mobVersion
      );
      context.commit("doSetStaticContentList", staticContentList);
      console.log(staticContentList);
      console.log("loadStaticContentList -- end");
    },

    async loadRentProductRequirements(context) {
      console.log("loadRentProductRequirements -- start");
      let rentProductRequirements =
        await APIAdapter.listRentProductRequirements(
          context.state.appInstance,
          context.state.mobConfig.mobVersion
        );
      context.commit("doSetRentProductRequirements", rentProductRequirements);
      console.log(rentProductRequirements);
      console.log("loadRentProductRequirements -- end");
    },
  },

  modules: {},
});
